import { startTransition } from 'react';
import { consentSlice } from './persistentStorage';

/**
 * Помечает пользователя как принявшего AI-Assistant disclaimer.
 *
 * @param payload - значение, которое должно быть записано в persistent storage
 *                  consent-слайса (`true` — пользователь согласился, `false` —
 *                  отозвал согласие)
 * @kind action
 */
export const setAIAssistantConsent = (payload: boolean): void => {
    startTransition(() => {
        consentSlice.setIsAltyConsent(payload);
    });
};
